<template>
  <div class="quotation-container">
    <div class="quotation-form">
      <h2>电子屏报价计算器</h2>
      
      <!-- 类型选择 -->
      <div class="form-group">
        <label>显示屏类型</label>
        <select v-model="formData.screenType">
          <option value="LED">LED显示屏</option>
          <option value="LCD">LCD显示屏</option>
          <option value="OLED">OLED显示屏</option>
        </select>
      </div>

      <!-- 应用场景 -->
      <div class="form-group">
        <label>应用场景</label>
        <select v-model="formData.scene">
          <option value="indoor">室内</option>
          <option value="outdoor">室外</option>
          <option value="rental">租赁</option>
        </select>
      </div>

      <!-- 尺寸输入 -->
      <div class="form-group size-inputs">
        <label>屏幕尺寸</label>
        <div class="size-group">
          <input type="number" v-model="formData.width" placeholder="宽度(mm)">
          <span>×</span>
          <input type="number" v-model="formData.height" placeholder="高度(mm)">
        </div>
      </div>

      <!-- 分辨率选择 -->
      <div class="form-group">
        <label>分辨率</label>
        <select v-model="formData.resolution">
          <option value="HD">HD (1280×720)</option>
          <option value="FHD">Full HD (1920×1080)</option>
          <option value="4K">4K (3840×2160)</option>
        </select>
      </div>

      <!-- 数量输入 -->
      <div class="form-group">
        <label>数量</label>
        <input type="number" v-model="formData.quantity" min="1">
      </div>

      <!-- 额外服务 -->
      <div class="form-group">
        <label>额外服务</label>
        <div class="checkbox-group">
          <label>
            <input type="checkbox" v-model="formData.services.installation">
            专业安装
          </label>
          <label>
            <input type="checkbox" v-model="formData.services.maintenance">
            维护服务
          </label>
          <label>
            <input type="checkbox" v-model="formData.services.contentDesign">
            内容设计
          </label>
        </div>
      </div>

      <!-- 按钮组 -->
      <div class="button-group">
        <button class="calculate-btn" @click="calculatePrice">获取报价</button>
        <button class="contact-btn" @click="contactSales">联系销售</button>
      </div>

      <!-- 报价结果 -->
      <div v-if="showResult" class="price-result">
        <h3>预估报价</h3>
        <div class="price-details">
          <p>基础价格：¥{{ formatPrice(basePrice) }}</p>
          <p>服务费用：¥{{ formatPrice(servicePrice) }}</p>
          <p class="total-price">总价：¥{{ formatPrice(totalPrice) }}</p>
        </div>
        <div class="price-note">
          * 此报价为预估价格，实际价格可能会有所调整。如需详细报价，请联系销售。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotationCard',
  data() {
    return {
      formData: {
        screenType: 'LED',
        scene: 'indoor',
        width: '',
        height: '',
        resolution: 'FHD',
        quantity: 1,
        services: {
          installation: false,
          maintenance: false,
          contentDesign: false
        }
      },
      showResult: false,
      basePrice: 0,
      servicePrice: 0,
      totalPrice: 0
    }
  },
  methods: {
    calculatePrice() {
      // 基础单价（示例价格）
      const basePricePerSquareMeter = {
        LED: { indoor: 2000, outdoor: 3000, rental: 2500 },
        LCD: { indoor: 3000, outdoor: 4000, rental: 3500 },
        OLED: { indoor: 5000, outdoor: 6000, rental: 5500 }
      }

      // 分辨率系数
      const resolutionCoefficient = {
        HD: 1,
        FHD: 1.3,
        '4K': 1.8
      }

      // 计算面积（平方米）
      const area = (this.formData.width * this.formData.height) / 1000000
      
      // 计算基础价格
      this.basePrice = area * 
        basePricePerSquareMeter[this.formData.screenType][this.formData.scene] * 
        resolutionCoefficient[this.formData.resolution] *
        this.formData.quantity

      // 计算服务费用
      this.servicePrice = 0
      if (this.formData.services.installation) {
        this.servicePrice += this.basePrice * 0.1 // 安装费用为基础价格的10%
      }
      if (this.formData.services.maintenance) {
        this.servicePrice += this.basePrice * 0.15 // 维护费用为基础价格的15%
      }
      if (this.formData.services.contentDesign) {
        this.servicePrice += this.basePrice * 0.05 // 内容设计费用为基础价格的5%
      }

      // 计算总价
      this.totalPrice = this.basePrice + this.servicePrice
      
      this.showResult = true
    },

    contactSales() {
      // 这里可以添加联系销售的逻辑，比如打开联系表单或显示联系信息
      alert('请联系我们的销售团队：\n电话：400-123-4567\n邮箱：sales@example.com')
    },

    formatPrice(price) {
      return price.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>

<style scoped>
.quotation-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.quotation-form {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

select, input[type="number"] {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.size-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.size-group input {
  flex: 1;
}

.size-group span {
  color: #666;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
}

.button-group {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

button {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.calculate-btn {
  background-color: #1890ff;
  color: white;
}

.calculate-btn:hover {
  background-color: #40a9ff;
}

.contact-btn {
  background-color: #f0f0f0;
  color: #333;
}

.contact-btn:hover {
  background-color: #e8e8e8;
}

.price-result {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.price-details {
  margin: 15px 0;
}

.price-details p {
  margin: 8px 0;
  font-size: 16px;
}

.total-price {
  font-size: 20px !important;
  font-weight: bold;
  color: #1890ff;
}

.price-note {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}
</style>